module.exports = __webpack_public_path__ + "static/media/imjudo-a360.0551adad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imjudo-a360.png
// module id = 1369
// module chunks = 0